// extracted by mini-css-extract-plugin
export default {"fadeIn":"fadeIn_bca5c33e55ae5cfacd0d","fadeOut":"fadeOut_f5d90932b80383c3d0cc"};